module.exports = __webpack_public_path__ + "img/hohlschnitt_hellelfenbein_ral1015.543b7f0c.jpg";